module.exports = __webpack_public_path__ + "217cf5fa10c3cb3079b916846138eb53.woff2";